import React from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";

const EventHeader: React.FC = () => (
  <View
    style={{
      flexDirection: "row",
      paddingHorizontal: 15,
      paddingTop: 20,
      gap: 50,
    }}
  >
    <Text
      style={[AppFontStyle.BOLD_ANYBODY_18, { flex: 1, alignSelf: "center" }]}
    >
      Events Organizers
    </Text>
    {/* <TouchableOpacity>
      <Image
        source={AppImages.icPlus}
        style={{ height: 24, width: 24, alignSelf: "center" }}
        resizeMode="contain"
      />
    </TouchableOpacity> */}
  </View>
);

export default withErrorBoundary(EventHeader);
